/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Box } from "@material-ui/core";

import type { FC } from "react";

const COLOR_DARK_BG = "#333333";
const COLOR_LIGHT_BG = "#F5F5F5";
const COLOR_DARK_HOVER_BG = "#444444";
const COLOR_LIGHT_HOVER_BG = "#E8E8E8";
const COLOR_DISABLED_DARK = "#5c5c5c";
const COLOR_DISABLED_LIGHT = "#dedede";

export const StreamingIconButton: FC<{
  children: React.ReactNode;
  isDarkModeEnabled: boolean;
  disabled?: boolean;
  isBgColorEnabled?: boolean;
  onClick: () => void;
}> = ({
  children,
  isDarkModeEnabled,
  disabled = false,
  isBgColorEnabled = true,
  onClick,
}) => {
  const color = getIconButtonColor({
    isDarkModeEnabled,
    disabled,
  });

  const bgColor = getIconButtonBgColor({
    isDarkModeEnabled,
    isBgColorEnabled,
  });

  const hoverBgColor = getIconButtonHoverBgColor({
    isDarkModeEnabled,
    isBgColorEnabled,
    disabled,
  });

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      width={isBgColorEnabled ? "40px" : "32px"}
      height={"32px"}
      color={color}
      bgcolor={bgColor}
      borderRadius={"24px"}
      onClick={disabled ? undefined : onClick}
      css={css`
        cursor: ${disabled ? "normal" : "pointer"};
        transition: 0.5s;
        &:hover {
          background-color: ${hoverBgColor};
        }
      `}
    >
      {children}
    </Box>
  );
};

const getIconButtonColor = ({
  isDarkModeEnabled,
  disabled,
}: {
  isDarkModeEnabled: boolean;
  disabled: boolean;
}) => {
  if (disabled) {
    return isDarkModeEnabled ? COLOR_DISABLED_DARK : COLOR_DISABLED_LIGHT;
  }

  return isDarkModeEnabled ? "dark.icon.primary" : "light.icon.primary";
};

const getIconButtonBgColor = ({
  isDarkModeEnabled,
  isBgColorEnabled,
}: {
  isDarkModeEnabled: boolean;
  isBgColorEnabled: boolean;
}) => {
  if (isBgColorEnabled) {
    return isDarkModeEnabled ? COLOR_DARK_BG : COLOR_LIGHT_BG;
  }

  return "transparent";
};

const getIconButtonHoverBgColor = ({
  isDarkModeEnabled,
  isBgColorEnabled,
  disabled,
}: {
  isDarkModeEnabled: boolean;
  isBgColorEnabled: boolean;
  disabled: boolean;
}) => {
  if (!isBgColorEnabled) {
    return "transparent";
  }

  if (disabled) {
    return isDarkModeEnabled ? COLOR_DARK_BG : COLOR_LIGHT_BG;
  }

  return isDarkModeEnabled ? COLOR_DARK_HOVER_BG : COLOR_LIGHT_HOVER_BG;
};
